import { useMemo, useState } from 'react';
import { clampIncome, estimate, INCOME_RANGE, PAID_INITIAL_INDEX, PAID_STOPS, type Mode } from './calc';

// Headless calculator state: each variant builds its own UI on top of this.
// `paidIndex` indexes into PAID_STOPS so a range input can step 0/500/… up to the maximum contribution
// while still landing exactly on the minimum contribution.
export function useSvsEstimate() {
  const [mode, setModeState] = useState<Mode>('revenue');
  const [income, setIncome] = useState<number>(INCOME_RANGE.revenue.initial);
  const [paidIndex, setPaidIndex] = useState<number>(PAID_INITIAL_INDEX);

  const setMode = (next: Mode) => {
    if (next === mode) return;
    setModeState(next);
    // Keep the amount (and thus the slider position); only clamp to the new minimum.
    setIncome((v) => clampIncome(next, v));
  };

  const paid = PAID_STOPS[paidIndex];
  const result = useMemo(() => estimate(mode, income, paid), [mode, income, paid]);

  return {
    mode,
    setMode,
    income,
    setIncome,
    incomeRange: INCOME_RANGE[mode],
    paid,
    paidIndex,
    setPaidIndex,
    paidMaxIndex: PAID_STOPS.length - 1,
    ...result,
  };
}

export type SvsEstimate = ReturnType<typeof useSvsEstimate>;
